export interface SeaSpot {
  id: string
  name: string
  depth: string
  level: string
  features: string[]
  region: '동해안' | '서해안' | '남해안'
  latitude: number
  longitude: number
  address: string
}

export const seaSpots: SeaSpot[] = [
  // 동해안
  { id: 'uljin', name: '울진 후포항', depth: '10-30m', level: '중급 이상', features: ['투명한 수질', '다양한 해양 생물'], region: '동해안', latitude: 36.6767, longitude: 129.4556, address: '경북 울진군 후포면 후포항' },
  { id: 'gangneung', name: '강릉 사천항', depth: '5-20m', level: '초급 가능', features: ['접근성 좋음', '초보자 환영'], region: '동해안', latitude: 37.7547, longitude: 128.9038, address: '강원 강릉시 사천면' },
  { id: 'sokcho', name: '속초 청초호', depth: '10-25m', level: '중급', features: ['아름다운 경관', '안전한 환경'], region: '동해안', latitude: 38.2047, longitude: 128.5918, address: '강원 속초시' },
  { id: 'yangyang', name: '양양 하조대', depth: '10-30m', level: '중급 이상', features: ['맑은 바다', '서핑과 병행'], region: '동해안', latitude: 38.0500, longitude: 128.6200, address: '강원 양양군 현북면 하조대로' },
  { id: 'pohang', name: '포항 구룡포', depth: '15-35m', level: '상급', features: ['깊은 수심', '고급자 추천'], region: '동해안', latitude: 35.9914, longitude: 129.5634, address: '경북 포항시 남구 구룡포읍' },
  // 서해안
  { id: 'taean', name: '태안 만리포', depth: '5-15m', level: '초급 가능', features: ['넓은 해변', '가족 단위 추천'], region: '서해안', latitude: 36.8011, longitude: 126.1562, address: '충남 태안군 소원면 만리포해변로' },
  { id: 'boryeong', name: '보령 무창포', depth: '8-20m', level: '초중급', features: ['신비의 바닷길', '독특한 경험'], region: '서해안', latitude: 36.3292, longitude: 126.4734, address: '충남 보령시 웅천읍 무창포' },
  { id: 'gunsan', name: '군산 선유도', depth: '10-25m', level: '중급', features: ['섬 투어', '아름다운 낙조'], region: '서해안', latitude: 35.9100, longitude: 126.5016, address: '전북 군산시 옥도면 선유도' },
  // 남해안
  { id: 'yeosu', name: '여수 소리도', depth: '10-30m', level: '중급 이상', features: ['맑은 수질', '다이나믹한 지형'], region: '남해안', latitude: 34.7455, longitude: 127.7341, address: '전남 여수시 화정면 소리도' },
  { id: 'geoje', name: '거제 해금강', depth: '15-35m', level: '상급', features: ['절경 포인트', '고급자 추천'], region: '남해안', latitude: 34.7769, longitude: 128.7158, address: '경남 거제시 남부면 갈곶리' },
  { id: 'jeju', name: '제주 서귀포', depth: '10-40m', level: '중상급', features: ['다양한 수심', '열대어 관찰'], region: '남해안', latitude: 33.2541, longitude: 126.5600, address: '제주 서귀포시' },
]

export const SEA_REGION_COLORS: Record<SeaSpot['region'], string> = {
  '동해안': '#06B6D4',
  '서해안': '#3B82F6',
  '남해안': '#0EA5E9',
}

export function getSeaMapCenter(spots: SeaSpot[]): { lat: number; lng: number } {
  if (spots.length === 0) return { lat: 36.0, lng: 127.7 }
  const avgLat = spots.reduce((s, v) => s + v.latitude, 0) / spots.length
  const avgLng = spots.reduce((s, v) => s + v.longitude, 0) / spots.length
  return { lat: avgLat, lng: avgLng }
}
